import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useBookingsContext } from '../../../contexts/BookingsContext';

interface MiniCalendarProps {
  currentDay: Date;
  onDateChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  datePicker: Boolean;
}

const MiniCalendar = ({
  currentDay,
  onDateChange,
  minDate,
  maxDate,
  datePicker,
}: MiniCalendarProps) => {
  const { handleToolbarNavigate, currentDate, setCurrentDate } =
    useBookingsContext();

  const [localDate, setLocalDate] = useState(new Date());

  const getDaysInMonthWithPadding = (date: any) => {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const days = [];
    const paddingDaysBefore = startOfMonth.getDay();
    const paddingDaysAfter = 6 - endOfMonth.getDay();

    for (let i = 0; i < paddingDaysBefore; i++) {
      const day = new Date(
        startOfMonth.getFullYear(),
        startOfMonth.getMonth(),
        -i,
      );
      days.unshift(day);
    }

    for (let i = 1; i <= endOfMonth.getDate(); i++) {
      days.push(new Date(date.getFullYear(), date.getMonth(), i));
    }

    for (let i = 1; i <= paddingDaysAfter; i++) {
      const day = new Date(
        endOfMonth.getFullYear(),
        endOfMonth.getMonth(),
        endOfMonth.getDate() + i,
      );
      days.push(day);
    }

    return days;
  };

  const handlePrevMonth = () => {
    if (datePicker) {
      setLocalDate((prev) => {
        const newDate = new Date(prev);
        newDate.setMonth(newDate.getMonth() - 1);
        return newDate;
      });
    } else {
      const newDate = new Date(currentDate);
      newDate.setMonth(newDate.getMonth() - 1);
      setCurrentDate(newDate);
      handleToolbarNavigate('PREV', newDate);
    }
  };

  const handleNextMonth = () => {
    if (datePicker) {
      setLocalDate((prev) => {
        const newDate = new Date(prev);
        newDate.setMonth(newDate.getMonth() + 1);
        return newDate;
      });
    } else {
      const newDate = new Date(currentDate);
      newDate.setMonth(newDate.getMonth() + 1);
      setCurrentDate(newDate);
      handleToolbarNavigate('NEXT', newDate);
    }
  };

  const handleDateClick = (date: Date) => {
    if (datePicker) {
      setLocalDate(date);
      onDateChange(date);
    } else {
      setCurrentDate(date);
      onDateChange(date);
    }
  };

  const days = datePicker
    ? getDaysInMonthWithPadding(localDate)
    : getDaysInMonthWithPadding(currentDate);

  return (
    <div style={{ margin: '0.8rem', width: '18rem' }}>
      <Box
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontWeight: 500,
          }}>
          <span>
            {datePicker
              ? localDate.toLocaleString('default', { month: 'long' })
              : currentDate.toLocaleString('default', { month: 'long' })}{' '}
            {datePicker ? localDate.getFullYear() : currentDate.getFullYear()}
          </span>
        </div>
        <Box>
          <IconButton onClick={handlePrevMonth}>
            <ChevronLeft />
          </IconButton>
          <IconButton onClick={handleNextMonth}>
            <ChevronRight />
          </IconButton>
        </Box>
      </Box>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          gap: '0.1rem',
          textAlign: 'center',
        }}>
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
          <div
            key={index}
            style={{
              fontSize: '0.875rem',
              fontWeight: 'bold',
              width: '2rem',
              color: '#34485e89',
            }}>
            {day}
          </div>
        ))}
        {days.map((day, index) => {
          const iscurrentDate =
            day.getMonth() === currentDate.getMonth() &&
            day.getFullYear() === currentDate.getFullYear();
          const isSelectedDate =
            day.toDateString() === currentDay.toDateString();
          return (
            <div
              key={index}
              style={{
                fontSize: '0.75rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '2rem',
                height: '2rem',
                padding: '0.4rem',
                fontWeight: 500,
                color: isSelectedDate
                  ? '#fff'
                  : datePicker
                    ? '#7c86a2'
                    : iscurrentDate
                      ? '#7c86a2'
                      : '#a1a1a1',
                backgroundColor: isSelectedDate ? '#0b1339' : '#fafafa',

                cursor: day ? 'pointer' : 'default',
                borderRadius: '2rem',
              }}
              onClick={() => handleDateClick(day)}>
              {day ? day.getDate() : ''}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default MiniCalendar;
